<form class="modal-body" [formGroup]="form" (submit)="addSharing()" novalidate>
  <p class="centermodal__title mb-4">{{ 'documents.shareFolder.title' | translate: { folderName: folder?.name } }}</p>

  <div class="centermodal__form" formGroupName="shares">
    @if (!isGroup) {
      <app-email-input [label]="'documents.shareFolder.peopleEmails' | translate" formControlName="emails" #peopleEmails></app-email-input>
      <span class="field__placeholder field__placeholder--email">Ex. john&commat;domain.com, maria&commat;domain.com</span>
    } @else {
      <app-select
        placeholder="{{ 'documents.group' | translate }}"
        [options]="groupsAsOptions"
        formControlName="group_id"
        [disableSearch]="true"
        [isLoading]="groupsAsOptions === null"
        [optionsRequest]="organizationGroups.bind(this)"
      ></app-select>
    }

    <app-select
      placeholder="{{ 'documents.shareFolder.role' | translate }}"
      [options]="rolesAsOptions"
      formControlName="role"
      [disableSearch]="true"
      class="select--role"
      [isLoading]="isGroup && groupsAsOptions === null"
    ></app-select>

    @if (!isGroup) {
      <hr />

      <label class="field__holder" [appFormControlWrap]="form.get('shares.message')">
        <textarea type="text" class="field" formControlName="message" autocomplete="none" maxlength="500"></textarea>
        <span class="field__placeholder">{{ 'settings.message' | translate }}</span>
      </label>
    }
  </div>

  <div class="centermodal__button-group">
    <button class="btn-M btn-filled-cancel" type="button" (click)="modal.dismiss()">{{ 'button.back' | translate }}</button>
    <button class="btn-M btn-filled" type="submit">{{ 'button.share' | translate }}</button>
  </div>
</form>
